import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./ITixcontact.css";

/* Button link – apne route ke hisaab se badlo */
const LINKS = { contact: "/contact" };

/* ============================================================
   CONTENT  (client ka content – yahin se edit karo)
   ============================================================ */
const CONTENT = {
  badge: "CONTACT US",
  text: "Contact us to discuss your organization's requirements or explore a suitable pilot workflow.",
  chips: ["Your organization's requirements", "A suitable pilot workflow"],
  button: "Contact Us",
};

/* scroll-in hook */
const useInView = (threshold = 0.25) => {
  const ref = useRef(null);
  const [seen, setSeen] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;
    if (!("IntersectionObserver" in window)) {
      setSeen(true);
      return undefined;
    }
    const io = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setSeen(true);
          io.disconnect();
        }
      },
      { threshold }
    );
    io.observe(node);
    return () => io.disconnect();
  }, [threshold]);
  return [ref, seen];
};

const Mail = () => (
  <svg viewBox="0 0 24 24" width="34" height="34" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
  </svg>
);
const Arrow = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
);

const ITixContact = () => {
  const [ref, seen] = useInView();
  return (
    <section ref={ref} className={`cu ${seen ? "cu--in" : ""}`} id="contact-cta">
      <div className="cu__container">
        <div className="cu__card">
          <span className="cu__glow cu__glow--a" aria-hidden="true" />
          <span className="cu__glow cu__glow--b" aria-hidden="true" />

          <div className="cu__icon-wrap">
            <span className="cu__ripple" />
            <span className="cu__ripple cu__ripple--2" />
            <span className="cu__icon">
              <Mail />
            </span>
          </div>

          <span className="cu__pill">{CONTENT.badge}</span>
          <p className="cu__text">{CONTENT.text}</p>

          <ul className="cu__chips">
            {CONTENT.chips.map((c) => (
              <li key={c}>
                <span aria-hidden="true">✓</span>
                {c}
              </li>
            ))}
          </ul>

          <Link to={LINKS.contact} className="cu__btn">
            {CONTENT.button}
            <Arrow />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ITixContact;